import React from 'react';
import IconFuelStation from '../../audi-ui-components/icons/FuelStation';
import IconChargingStation from '../../audi-ui-components/icons/ChargingStation';
import { formatDollar } from '../../functions/textFormatting';

const Vehicle = ({ rbData, showEstimate }) => {
    return (
        <div className="vehicle">
            <p className="aui-font-extended"><b>{rbData.make} {rbData.family} {rbData.year}</b></p>
            <p>{rbData.description}</p>
            <hr className="my-3" />
            <div className="d-flex vehicle-stats">
                {rbData.fuelType && <span>{rbData.fuelType === "Electric" ? <IconChargingStation small /> : <IconFuelStation small />} {rbData.fuelType}</span>}
                {rbData.gearType && <span><svg className="audiicon audiicon-small" width="24" height="24" viewBox="0 0 24 24"><path d="M22.5,5 L22.5,20 M15.5,5 L15.5,20 M8.5,5 L8.5,20 M1.5,5 L1.5,12.5 L22.5,12.5" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd"/></svg> {rbData.gearType}</span>}
            </div>
            {showEstimate && <>
              <hr className="mb-3" />
              <div className="estimate"><b>
                  {formatDollar(rbData.tradeInMin)}
                  <span className="estimate-arrow" />
                  {formatDollar(rbData.tradeInMax)}
              </b></div>
            </>}
        </div>
    );
}

export default Vehicle;
